import React from 'react';

function Privacy() {
  return (
    <>
      <section className="hero">
        <div className="hero__inner">
          <div className="hero__content">
            <div className="hero__text-content">
              <h1 className="hero__title">Kebijakan Privasi</h1>
              <p className="hero__subtitle">
                Perlindungan data Anda adalah prioritas kami
              </p>
              <div className="hero__divider"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="about">
        <div className="about__inner">
          <div className="about__content">
            <div className="section-header">
              <h2 className="section-title">Kebijakan Privasi</h2>
              <p className="section-subtitle">Perlindungan data Anda adalah prioritas kami</p>
            </div>
            
            <div className="about__main-content">
              <p>
                Di Cakra Digital Innovation, kami berkomitmen untuk melindungi privasi dan keamanan data pribadi Anda. 
                Kebijakan privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi Anda.
              </p>
              
              <h3>Data yang Kami Kumpulkan</h3>
              <p>
                Kami hanya mengumpulkan informasi yang diperlukan untuk menyediakan layanan kami, 
                termasuk nama, email, nomor telepon, dan informasi proyek yang relevan.
              </p>
              
              <h3>Penggunaan Data</h3>
              <p>
                Data yang kami kumpulkan digunakan untuk:
                <ul>
                  <li>Menyediakan layanan yang diminta</li>
                  <li>Komunikasi terkait proyek</li>
                  <li>Penyediaan dukungan teknis</li>
                  <li>Peningkatan layanan kami</li>
                </ul>
              </p>
              
              <h3>Keamanan Data</h3>
              <p>
                Kami menerapkan langkah-langkah keamanan yang wajar untuk melindungi data Anda 
                dari akses tidak sah, penggunaan yang tidak tepat, atau perubahan.
              </p>
              
              <h3>Kontak</h3>
              <p>
                Jika Anda memiliki pertanyaan tentang kebijakan privasi kami, 
                silakan hubungi kami di cdiyunoru@gmail.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Privacy;
